const Constants = {
    META_MASK_WALLET: 'metaMask',
    TRON_LINK_WALLET: 'tronLink',
    NOT_AVAILABLE: 'Not Available',
    META_MASK_WALLET_DOWNLOAD_LINK: 'https://metamask.io/download/',
    TRON_LINK_WALLET_DOWNLOAD_LINK: 'https://www.tronlink.org/dlDetails/'
}

export default Constants;
